export interface MasterSnak {
  name: string
  cognitiveAnchor: string
  emotionalPayoff: string
  visualLead: string
  visualDetail: string
  deckPage: string
  source: string
}

export const masterSnaks: MasterSnak[] = [
  {
    name: 'MoA',
    cognitiveAnchor: 'Mechanistic clarity',
    emotionalPayoff: 'Scientific confidence',
    visualLead: 'CD20 × CD3 bispecific mechanism diagram',
    visualDetail: 'Binding + T-cell activation visual',
    deckPage: 'Deck p.8',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
  {
    name: 'Survival',
    cognitiveAnchor: 'Curative potential',
    emotionalPayoff: 'Hope + impact',
    visualLead: '3-year Overall Survival Kaplan–Meier curve',
    visualDetail: 'Separation animation',
    deckPage: 'Deck p.15',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
  {
    name: 'Disease control',
    cognitiveAnchor: 'Durability',
    emotionalPayoff: 'Predictability',
    visualLead: 'Progression-Free Survival curve',
    visualDetail: 'Durability highlight',
    deckPage: 'Deck p.19',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
  {
    name: 'Depth of response',
    cognitiveAnchor: 'Strength of effect',
    emotionalPayoff: 'Clinical trust',
    visualLead: 'Complete remission comparison chart',
    visualDetail: 'CR doubling animation',
    deckPage: 'Deck p.17',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[51].pdf',
  },
  {
    name: 'Guidelines',
    cognitiveAnchor: 'External validation',
    emotionalPayoff: 'Practice confidence',
    visualLead: 'EHA/ESMO treatment pathway graphic',
    visualDetail: 'Recommendation highlight',
    deckPage: 'Deck p.22',
    source: 'Columvi 2L Core Sales Aid_V2 (3)[41].pdf',
  },
]
